import React from 'react'
import "../css/addToCart.css";
import { GroupF, GroupG } from "../component/footer";
import { Helmet } from "react-helmet-async";

function Termsandcondition() {
  return (
    <>
    <Helmet>
      <title>Terms and Conditions</title>
    </Helmet>
    <div className="terms-conditions-container">
      <h1>Terms and Conditions for Selling Beats on urbeathub.com</h1>
  
      <h2>Introduction</h2>
      <p>
        Welcome to Ur BeatHub. These Terms and Conditions ("Agreement") govern the relationship between <strong>Ur BeatHub</strong> and any individual or entity ("Seller") that sells beats through the Platform. By registering as a Seller and using the Platform, you agree to be bound by the terms of this Agreement.
      </p>
  
      <h2>1. Registration and Account</h2>
      <p><strong>1.1 Eligibility:</strong> To register as a Seller, you must be at least 18 years old and capable of entering into a binding agreement.</p>
      <p><strong>1.2 Account Information:</strong> You must provide accurate and complete information during the registration process and keep your account information up to date.</p>
      <p><strong>1.3 Account Security:</strong> You are responsible for maintaining the confidentiality of your account login details and for all activities that occur under your account. Notify the Platform Owner immediately of any unauthorized use of your account.</p>
  
      <h2>2. Selling Beats</h2>
      <p><strong>2.1 Content Requirements:</strong> Sellers must ensure that all beats uploaded to the Platform are original works and do not infringe on any third-party rights.</p>
      <p><strong>2.2 Licensing:</strong> By uploading beats to the Platform, Sellers grant the Platform Owner a non-exclusive, worldwide, royalty-free license to use, reproduce, distribute, and display the beats for the purpose of operating and promoting the Platform.</p>
      <p><strong>2.3 Pricing:</strong> Sellers set the prices for their beats. The Platform Owner reserves the right to apply discounts or promotions to the beats.</p>
      <p><strong>2.4 Sales and Payments:</strong> The Platform Owner will handle all sales transactions. Sellers will receive [percentage]% of the net sales revenue from their beats. Payments will be made [monthly/bi-weekly] via [payment method].</p>
  
      <h2>3. Prohibited Conduct</h2>
      <p><strong>3.1 Infringement:</strong> Sellers must not upload any beats that infringe on the intellectual property rights of others.</p>
      <p><strong>3.2 Misrepresentation:</strong> Sellers must not misrepresent the origin, authorship, or ownership of their beats.</p>
      <p><strong>3.3 Compliance:</strong> Sellers must comply with all applicable laws and regulations when using the Platform.</p>
  
      <h2>4. Intellectual Property</h2>
      <p><strong>4.1 Ownership:</strong> Sellers retain all rights to their beats, subject to the license granted to the Platform Owner in Section 2.2.</p>
      <p><strong>4.2 Trademarks:</strong> Sellers may not use the Platform Owner's trademarks, logos, or other proprietary information without prior written consent.</p>
  
      <h2>5. Termination</h2>
      <p><strong>5.1 Termination by Seller:</strong> Sellers may terminate their account at any time by providing written notice to the Platform Owner.</p>
      <p><strong>5.2 Termination by Platform Owner:</strong> The Platform Owner reserves the right to suspend or terminate a Seller's account for any reason, including violation of this Agreement, with or without notice.</p>
      <p><strong>5.3 Effect of Termination:</strong> Upon termination, the Seller's beats will be removed from the Platform, and any pending payments will be processed according to the regular payment schedule.</p>
  
      <h2>6. Limitation of Liability</h2>
      <p><strong>6.1 No Warranty:</strong> The Platform is provided "as is" without warranties of any kind. The Platform Owner does not guarantee the availability or functionality of the Platform.</p>
      <p><strong>6.2 Limitation of Liability:</strong> The Platform Owner will not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or relating to this Agreement.</p>
  
      <h2>7. Indemnification</h2>
      <p>
        Sellers agree to indemnify and hold harmless the Platform Owner, its affiliates, and their respective officers, directors, employees, and agents from any claims, damages, liabilities, and expenses arising out of or related to the Seller's use of the Platform or violation of this Agreement.
      </p>
  
      <h2>8. Governing Law and Dispute Resolution</h2>
      <p><strong>8.1 Governing Law:</strong> This Agreement will be governed by and construed in accordance with the laws of [State/Country].</p>
      <p><strong>8.2 Dispute Resolution:</strong> Any disputes arising out of or relating to this Agreement will be resolved through [mediation/arbitration/court] in [Jurisdiction].</p>
  
      <h2>9. Amendments</h2>
      <p>
        The Platform Owner reserves the right to modify this Agreement at any time. Sellers will be notified of any changes, and continued use of the Platform constitutes acceptance of the revised terms.
      </p>
  
      <h2>10. Entire Agreement</h2>
      <p>
        This Agreement constitutes the entire agreement between the Platform Owner and the Seller and supersedes all prior or contemporaneous understandings, agreements, or representations.
      </p>
  
      <p>If you have any questions or concerns about these Terms and Conditions, please contact us at <a href="mailto:info@urbeathub.com">info@urbeathub.com</a>.</p>
  
      <p>
        By registering as a Seller and using the Platform, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions.
      </p>
    </div>
  </>
  
  )
}

export default Termsandcondition